import React, { useState } from 'react';
import '../css/inquiryBanner.css';

const InquiryBanner = () => {
  const [showPhoneNumber, setShowPhoneNumber] = useState(false);
  const phoneNumber = '+91 8488880446';

  const handleCallNowClick = (e) => {
    e.preventDefault();
    setShowPhoneNumber(!showPhoneNumber);
  };

  return (
    <section className="inquiry-banner">
      <div className="container">
        <div className="banner-content">
          <div className="banner-text">
            <h2 className="banner-title">
              Ready to Experience Excellence?
            </h2>
            <p className="banner-subtitle">
              Get a customized quote for your industrial valve requirements. 
              Our expert team is ready to provide solutions tailored to your specific needs.
            </p>
            <div className="banner-features">
              <div className="feature">
                <div className="feature-icon">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/>
                    <path d="M22 4L12 14.01l-3-3"/>
                  </svg>
                </div>
                <span>Free Consultation</span>
              </div>
              <div className="feature">
                <div className="feature-icon">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <circle cx="12" cy="12" r="10"/>
                    <path d="M12 6v6l4 2"/>
                  </svg>
                </div>
                <span>Quick Response</span>
              </div>
              <div className="feature">
                <div className="feature-icon">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M12 2L2 7v10l10 5 10-5V7L12 2z"/>
                    <path d="M12 22V12"/>
                  </svg>
                </div>
                <span>Custom Solutions</span>
              </div>
            </div>
          </div>
          
          <div className="banner-actions">
            <div className="action-buttons">
              <button onClick={handleCallNowClick} className="btn-secondary">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"/>
                </svg>
                <span>Call Now</span>
              </button>
              {showPhoneNumber && (
                <div className="phone-number-display">
                  <a href={`tel:${phoneNumber.replace(/\s/g, '')}`} className="phone-link">
                    {phoneNumber}
                  </a>
                </div>
              )}
            </div>
            
            <div className="inquiry-contact-info">
              <div className="inquiry-contact-item">
                <div className="inquiry-contact-icon">
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
                    <polyline points="22,6 12,13 2,6"/>
                  </svg>
                </div>
                <div className="inquiry-contact-details">
                  <span className="inquiry-contact-label">Email</span>
                  <span className="inquiry-contact-value">naikars@anuflowcontrols.com</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default InquiryBanner;
